import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { articleDateContent$key } from "~/queries/__generated__/articleDateContent.graphql";

import { DefaultArticleDate } from "./default-article-date";

export type Props = {
  reference: articleDateContent$key;
};

export const ArticleDate: FunctionComponent<Props> = ({ reference: reference_, ...attribs }) => {
  const content = useFragment(
    graphql`
      fragment articleDateContent on Content {
        ...defaultArticleDateContent
      }
    `,
    reference_,
  );

  if (!content) return null;

  return <DefaultArticleDate reference={content} {...attribs} />;
};

ArticleDate.displayName = "ArticleDate";
